import $ from 'jquery';

function loadIn(video) {

	let text = $('#hero .content .text');
	let logo = $('.header .header_logo > a');

	logo.css('display', 'none');
	logo.css('color', '#80bc00');
	text.css('color', '#80bc00');

	// setTimeout(()=>{
		text.slideDown(500);
		logo.slideDown(500);
		setTimeout(()=>{
			setTimeout(()=>{
				video.play();
				$('.hero').addClass('-start');
				text.css('color', '');
				logo.css('color', '');
			}, 500);
		}, 400);
	// }, 300);
}

export default function heroSection() {
	const $html = $('html');
	const $scroller = $('html, body');

	const HERO = $('#hero');

	if (HERO.length) {
		$(function(){
			let videoElement = HERO.find('video');

			let video;

			if (videoElement.length) {
				video = videoElement[0];
				video.pause();
			}

			if (videoElement.length) {
				loadIn(video)
			}

			// if ($('.hero-loading').length > 0) {
			// 	setTimeout(()=>{
			// 		$('.hero-loading').fadeOut(500, ()=>{
			// 			$('.hero-loading').remove();
			// 		});
			// 		if (videoElement.length) {
			// 			loadIn(video)
			// 		}
			// 	}, 700);
			// } else {
			// 	if (videoElement.length) {
			// 		loadIn(video)
			// 	}
			// }
		});
	}
}



// WEBPACK FOOTER //
// ./source/scripts/sections/hero.js